import { TlsCertRead, TlsCertWrite } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class TlsApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  getTls(): Promise<TlsCertRead> {
    return this.edgeClient.getTls()
  }
  saveTls(params: TlsCertWrite): Promise<TlsCertRead> {
    return this.edgeClient.setTls(params)
  }
}
